import React from 'react';
import { Box } from '@mui/material';
import { CustomerAnalyticsDashboardCards } from './CustomerAnalyticsDashboardCards';
import { AllCustomersTable } from '../table/AllCustomersTable';

export const CustomerAnalyticsDashboardContent = ({ 
  loading,
  tableLoading,
  totalCustomers,
  activeCustomers,
  totalApiCalls,
  totalCreditConsumed,
  customers,
  totalCustomersCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  successRateChange,
  totalRequestsChangePercentage,
  usagePercentage,
}) => {
  return (
    <Box>
      {/* Dashboard Cards */}
      <Box sx={{ mb: 2 }}>
        <CustomerAnalyticsDashboardCards
        loading={loading}
          totalCustomers={totalCustomers}
          activeCustomers={activeCustomers}
          totalApiCalls={totalApiCalls}
          successRateChange={successRateChange}
          totalRequestsChangePercentage={totalRequestsChangePercentage}
          totalCreditConsumed={totalCreditConsumed}
          usagePercentage={usagePercentage}
        />
      </Box>

       {/* Customers Table */}
       <Box sx={{ mt: 3 }}>
       <AllCustomersTable
          tableLoading={tableLoading}
          data={customers}
          totalCount={totalCustomersCount}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </Box>
      <Box sx={{ mt: 1 }}> </Box>
    </Box>
  );
};